module.exports = __webpack_public_path__ + "img/icon_mokuai_on.09d47749.png";